import * as React from 'react'
import { Property } from 'csstype'

import theme from 'theme'
import Text from 'components/common/Text'

const EmptyCard: React.FC<{
  title: string
  titleColor?: Property.Color
}> = ({ titleColor = theme.colors.steel[1], title, children }) => (
  <div
    data-test-empty-card
    css={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }}
  >
    <Text
      as="h3"
      css={{
        marginBottom: theme.space[2],
        color: titleColor
      }}
    >
      {title}
    </Text>
    {children}
  </div>
)
export default EmptyCard
